import styled from "styled-components";

export const PageStyle = styled.div`
    width: 75%;
    min-width: 650px;
    margin: 0 auto;

    @media (max-width: 1280px) {
        width: 100%;
        padding: 0 1rem;
    }

    @media (max-width: 1030px) {
        width: 100%;
        min-width: unset;
        padding: 0 1rem;
    }

    @media (max-width: 750px) {
        width: 100%;
        min-width: unset;
        padding: 0;
    }
`;